import { useState, useEffect } from 'react';

const useDownloadsContent = () => {
  const [content, setContent] = useState({
    changelogs: {
      windows: [],
      android: []
    },
    faq: [],
    loading: true,
    error: null
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/resources/data/downloads-content.json`);
        
        if (!response.ok) {
          throw new Error(`Error fetching content: ${response.status}`);
        }
        
        const data = await response.json();
        
        setContent({
          changelogs: {
            windows: data.changelogs?.windows || [],
            android: data.changelogs?.android || []
          },
          faq: data.faq || [],
          loading: false,
          error: null
        });
      } catch (err) {
        console.error("Failed to load downloads content:", err);
        setContent(prev => ({
          ...prev,
          loading: false,
          error: err.message
        }));
      }
    };

    fetchContent();
  }, []);

  return content;
};

export default useDownloadsContent;
